module.exports = __webpack_public_path__ + "img/夏天无.864294a0.jpg";